import React, { FC } from "react"

import {
    HeartOutlined,
    HomeOutlined,
    LogoutOutlined,
    SafetyCertificateOutlined,
    TeamOutlined,
    UnorderedListOutlined,
} from "@ant-design/icons"
import { Menu } from "antd"
import { Link } from "react-router-dom"

import styles from "./Nav.module.scss"
import { MenuItem } from "../../../types/nav"
import { adminRole } from "../../constants/roles"
import { routeNames } from "../../constants/routes"
import { useActions } from "../../hooks/useActions"
import { useAllowedRoles } from "../../hooks/useAllowedRoles"

const getItem = (
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    onClick?: (info: string) => void
): MenuItem => {
    return {
        key,
        icon,
        children,
        label,
        onClick
    } as MenuItem
}

const Nav: FC = () => {

    const isAdmin = useAllowedRoles([adminRole])

    const { authLogout } = useActions()

    const items: MenuItem[] = [
        getItem(<Link to={routeNames.home}>Объявления</Link>, "nav-ads", <UnorderedListOutlined />),
        getItem(<Link to={routeNames.favorites}>Избранное</Link>, "nav-favorites", <HeartOutlined />),
        getItem(<Link to={routeNames.cianSettings}>ЦИАН</Link>, "nav-cian", <HomeOutlined />),
        isAdmin ? getItem(<Link to={routeNames.staff}>Сотрудники</Link>, "nav-staff", <TeamOutlined />) : null,
        isAdmin ? getItem(<Link to={routeNames.access}>Доступ</Link>, "nav-access", <SafetyCertificateOutlined />) : null,
        getItem(<a onClick={() => authLogout()}>Выйти</a>, "nav-logout", <LogoutOutlined />)
    ].filter((item) => item !== null)

    return (
        <>
            <div className={styles.logoWrapper}>
                <Link to={routeNames.home}>
                    <b>AV</b>CRM
                </Link>
            </div>
            <Menu
                theme="dark"
                mode="inline"
                items={items}
                selectable={false}
            />
        </>
    )
}

export default Nav
